/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@compiled/react';
import { defineMessages, useIntl } from 'react-intl';

import Link from '@atlaskit/link/link';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		backgroundColor: token('color.background.accent.teal.bolder'),
		paddingBlock: token('space.150'),
		paddingInline: token('space.200'),
		borderRadius: token('radius.xlarge'),
		textAlign: 'center',
	},
});

const messages = defineMessages({
	feedbackBannerText: {
		id: 'ai-mate.conversation-assistant.session-right-panel.feedback-banner-text-non-final',
		defaultMessage: "🧪 Internal experiment - Don't demo externally {feedbackChannelLink}",
		description: 'Text for the feedback banner shown at the top of the session context panel.',
	},
});

export const FeedbackBanner = (): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.root}>
			<Text color="color.text.inverse">
				{formatMessage(messages.feedbackBannerText, {
					feedbackChannelLink: (
						<Text as="span" weight="bold" color="color.text.inverse">
							<Link
								href="https://atlassian.enterprise.slack.com/archives/C0BK8TXT3S5"
								target="_blank"
								rel="noopener noreferrer"
								appearance="inverse"
							>
								#feedback-agent-session-experience
							</Link>
						</Text>
					),
				})}
			</Text>
		</Box>
	);
};
